import React, { useEffect, useState } from "react";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import { Button, Input } from "antd";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import useReactEditor from "../hooks/useReactEditor";
import { connect } from "react-redux";
import { setArticle } from "./ducks";
import Axios from "axios";

const EditOnlineArticle = ({
  activeArticle: { course, html, title, _id, isPublished },
  setArticle,
  history
}) => {
  const {
    editorState,
    onEditorStateChange,
    uploadImageCallBack
  } = useReactEditor(null);
  const [isLoading, setIsLoading] = useState(false);
  const [editingTitle, setEditingTitle] = useState(title);

  useEffect(() => {
    const loadHTMLToDraft = () => {
      const contentBlock = htmlToDraft(html);
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks
        );
        onEditorStateChange(EditorState.createWithContent(contentState));
      }
    };
    loadHTMLToDraft();
    // eslint-disable-next-line
  }, []);
  return (
    <React.Fragment>
      {isLoading && <div className="loading">Loading&#8230;</div>}
      <div className="mb-3 bg-white pl-4 pr-4 pt-2 pb-2">
        <h1>{title} </h1>
      </div>
      <Input
        size="large"
        placeholder="Title"
        style={{ marginBottom: 12 }}
        value={editingTitle}
        onChange={e => setEditingTitle(e.target.value)}
      />
      <Editor
        editorState={editorState}
        onEditorStateChange={onEditorStateChange}
        toolbar={{
          image: {
            uploadCallback: uploadImageCallBack,
            alt: { present: true, mandatory: false }
          }
        }}
      />
      <div style={{ display: "flex", justifyContent: "center", marginTop: 12 }}>
        <Button
          type="primary"
          size="large"
          disabled={editorState === null}
          style={{ minWidth: 120 }}
          onClick={async () => {
            setIsLoading(true);
            const body = {
              html: draftToHtml(convertToRaw(editorState.getCurrentContent())),
              title: editingTitle,
              course_id: course,
              isPublished
            };
            try {
              const res = await Axios.put(`/online-article/${_id}`, body);
              setArticle(res.data.article);
              setIsLoading(false);
              history.push("/article/online/" + res.data.article._id);
            } catch (error) {
              throw error;
            }
          }}
        >
          Save
        </Button>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = state => ({
  activeArticle: state.articles.activeArticle
});

const mapDispatchToProps = {
  setArticle
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditOnlineArticle);
